var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.896,
    height: 15,
    viewBox: "0 0 15.896 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2061.729 -1137.886)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2102.729,1192.99v-3.956l1.312-.744,2.478-1.4,3.747,2.147v3.956l-3.747,2.089Z",
    transform: "translate(41 -42.192)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2102.729,1192.99v-3.956l1.312-.744,2.478-1.4,3.747,2.147v3.956l-3.747,2.089Z",
    transform: "translate(45.207 -49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2102.729,1192.99v-3.956l1.312-.744,2.478-1.4,3.747,2.147v3.956l-3.747,2.089Z",
    transform: "translate(49.358 -42.192)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexbin);
export default __webpack_public_path__ + "static/media/hexbin.16a9ae80.svg";
export { ForwardRef as ReactComponent };